import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

import { questionPoolEndpoints } from './question-pool.constants'
import type { TQuestionPool, TQuestionPoolStatus } from './question-pool.types'

export async function getQuestionPoolList(
  status?: TQuestionPoolStatus
): Promise<TQuestionPool[]> {
  const res = await api.get<TResponse<TQuestionPool[]>>(
    questionPoolEndpoints.list,
    { params: status ? { status } : undefined }
  )
  return res.data.data
}
